<template>
  <div class="chatbot-service-list">
    <el-row :gutter="20">
      <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" v-for="item in serviceList" :key="item.key">
        <div class="service-item" @click="getServiceQuestionList(item.value)">
          <a><img :src="item.img" width="100%" height="100%" /></a>
          <p style="margin: 0 0 5px 0;">{{ item.value }}</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { sendMessage } from "@/api/chatbot";
import { isObject, messageParse } from "@/utils";
import { IndexPageModule } from "@/settings";

export default {
  name: "ChatbotService",
  data() {
    return {
      serviceList: IndexPageModule,
    };
  },
  methods: {
    async getServiceQuestionList(value) {
      const res = await sendMessage(value);
      let result = res.data
      if (isObject(res.data)) result = res.data.result
      const data = messageParse(result);
      const { item_id } = data;
      this.$store.commit("set_messageList", data);
      this.$store.commit("set_itemId", item_id);
    },
  },
};
</script>
<style>
.chatbot-service-list {
  text-align: center;
  margin: 10px 60px;
}

.chatbot-service-list .service-item {
  text-align: center;
  /* padding: 3px; */
}

.chatbot-service-list .service-item img {
  max-width: 90px;
  max-height: 85px;
}

/* .chatbot-service-list .service-item p {
  font-size: 14px;
  line-height: 1.2;
} */

</style>
